import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ec-header',
  templateUrl: 'header.html'
})
export class HeaderComponent implements OnInit {
  @Input() menuTitle: string = "SOCOTEC Avantage";
  @Input() navStyle: string = "";
  @Input() pictoLeft: string = "";
  @Input() pictoRight: string = "";
  @Input() hasPictoLeft: boolean = true;
  @Input() hasSearch: boolean = false;
  @Input() nomElement: string = "";
  @Output() pictoLeftClick = new EventEmitter();
  @Output() pictoRightClick = new EventEmitter();
  @Output() getSearch = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/pages/header/header.ts